import React from 'react'
import Select from 'antd/es/select'
import AntdTag from 'antd/es/tag'
import BaseField from './BaseField'
import { Spinner } from 'components/spinner'
import { isColorLight } from '@eventops/utils'


export default function FieldSelect(props) {
  /* Input Dropdown
   * Expected Props:
   * className = <string> Optional
   * label = <string> Required
   * required = <boolean> Optional
   * name = <string> Required
   * value = <string> Required
   * values = [{ label: <string>, value: <string>, color: <string> Optional }] Required
   * valid = <boolean> Optional
   * validMessage = <string> Optional
   * invalidMessage = <string> Optional
   * help = <string> Optional
   * helpAboveInput = <boolean> Optional
   * onChange = <function()> Required
   * onBlur = <function()> Optional
   * disabled = <boolean> Optional
   * readOnly = <boolean> Optional
   * prepend = <string> Optional
   * append = <string> Optional
   * multiple = <boolean> Optional
   * isLoading = <boolean> Optional
   * horizontal = <boolean> Optional
   * horizontalLabelSize = <int [1-23]> Optional (Default = 6)
   * tagRender = <boolean> Optional (Default = false. Only works if multiple)
   */
  const defaultColor = "#f5f5f5"
  const value = props.values?.filter(
    v => props.labelInValue ? props.value?.value?.includes(v.value) : props.value?.includes(v.value)
  ).map(v => ({ label: v.label, value: v.value })) || []
  const options = props.values?.filter(
    v => !props.multiple || (props.labelInValue ? !props.value?.value?.includes(v.value) : !props.value?.includes(v.value))
  ) || []
  const optionsColors = props.multiple && props.tagRender ? Object.fromEntries(props.values?.map(v => [v.value, v.color]) || []) : {}
  const isDisabled = (props.disabled || props.readOnly) && true

  // FUNCTIONS
  const onChange = newValue => {
    props.onChange(props.multiple ? {target: {value: newValue.map(v => v.value)}} : {target: {value: newValue?.value}})
  }

  // RENDER
  const tagRender = ({ label, value, closable, onClose }) => {
    const color = optionsColors[value] || defaultColor
    return <AntdTag
      className={isColorLight(color) ? "text-black" : "text-white"}
      color={color}
      closable={closable}
      onClose={onClose}
    >
      {label}
    </AntdTag>
  }

  return (
    <BaseField
      className={props.className}
      labelClassName={props.labelClassName}
      inputClassName={props.inputClassName}
      label={props.label}
      input={
        <Select
          ref={props.inputRef}
          className={"form-control custom-field-input" + (
            props.valid === true ? " is-valid" : props.valid === false ? " is-invalid" : ""
          )}
          mode={props.multiple ? "multiple" : undefined}
          disabled={isDisabled}
          readOnly={props.readOnly}
          autoFocus={props.autoFocus}
          suffixIcon={props.isLoading ? <Spinner /> : undefined}
          notFoundContent={props.isLoading ? "Loading..." : undefined}
          placeholder={props.placeholder}
          allowClear={props.allowClear !== false}
          onChange={onChange}
          optionFilterProp="label"
          onBlur={props.onBlur}
          value={value}
          showArrow={!isDisabled}
          labelInValue
          options={options}
          tagRender={props.tagRender ? tagRender : undefined}
        />
      }
      prepend={props.prepend}
      append={props.append}
      disabled={props.disabled}
      readOnly={props.readOnly}
      required={props.required}
      valid={props.valid}
      validMessage={props.validMessage}
      invalidMessage={props.invalidMessage}
      help={props.help}
      helpAboveInput={props.helpAboveInput}
      horizontal={props.horizontal}
      horizontalLabelSize={props.horizontalLabelSize}
    />
  )
}
